import { render, staticRenderFns } from "./JsonFormsEditor.vue?vue&type=template&id=091159e8&"
import script from "./JsonFormsEditor.vue?vue&type=script&lang=js&"
export * from "./JsonFormsEditor.vue?vue&type=script&lang=js&"
import style0 from "./JsonFormsEditor.vue?vue&type=style&index=0&id=091159e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports